// Currency helpers shared across Events and Library pages.
// Keep the list in sync with SUPPORTED_CURRENCIES in /app/backend/server.py.

export const CURRENCY_OPTIONS = [
    { value: 'eur', code: 'EUR', symbol: '€', label: 'EUR (€) — Euro' },
    { value: 'gbp', code: 'GBP', symbol: '£', label: 'GBP (£) — Pound Sterling' },
    { value: 'usd', code: 'USD', symbol: '$', label: 'USD ($) — US Dollar' },
    { value: 'chf', code: 'CHF', symbol: 'CHF', label: 'CHF — Swiss Franc' },
    { value: 'cad', code: 'CAD', symbol: 'CA$', label: 'CAD — Canadian Dollar' },
    { value: 'aud', code: 'AUD', symbol: 'A$', label: 'AUD — Australian Dollar' },
];

const CURRENCY_BY_VALUE = Object.fromEntries(CURRENCY_OPTIONS.map(c => [c.value, c]));

/** Return the symbol for a currency code (lowercase ISO), defaulting to €. */
export function currencySymbol(value) {
    const key = (value || 'eur').toString().toLowerCase();
    return (CURRENCY_BY_VALUE[key] || CURRENCY_BY_VALUE.eur).symbol;
}

/** Format a price with the right currency symbol: 10 EUR -> "10€", 10 USD -> "$10". */
export function formatPrice(amount, currency) {
    const sym = currencySymbol(currency);
    const num = Number.isFinite(Number(amount)) ? Number(amount) : 0;
    // Prefix for $-style, suffix for €-style — a tiny concession to how each
    // feels native when read.
    if (sym === '$' || sym === 'CA$' || sym === 'A$') return `${sym}${num}`;
    if (sym === '£') return `${sym}${num}`;
    if (sym === 'CHF') return `${num} CHF`;
    return `${num}${sym}`; // € default
}

/** Format a converted amount — rounds to a sensible 2-dp view and uses the
 *  Intl.NumberFormat for grouping while keeping the symbol style of formatPrice. */
export function formatInCurrency(amount, currency) {
    const sym = currencySymbol(currency);
    const num = Number.isFinite(Number(amount)) ? Number(amount) : 0;
    // Round to 2dp (half-up) and strip trailing .00 for cleaner reading on whole prices
    const rounded = Math.round(num * 100) / 100;
    const formatted = (Number.isInteger(rounded) ? rounded.toString() : rounded.toFixed(2));
    if (sym === '$' || sym === 'CA$' || sym === 'A$') return `${sym}${formatted}`;
    if (sym === '£') return `${sym}${formatted}`;
    if (sym === 'CHF') return `${formatted} CHF`;
    return `${formatted}${sym}`;
}
